import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSalesProcessRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5 4a.999.999 0 1 1 0 2 .999.999 0 1 1 0-2m.75 3.384A2.499 2.499 0 0 0 5 2.5a2.5 2.5 0 0 0-.75 4.884V9.25h-2.5A.75.75 0 0 0 1 10c0 .416.334.75.75.75h7.5v1.866A2.499 2.499 0 0 0 10 17.5a2.5 2.5 0 0 0 .75-4.884V10.75h7.5c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75h-2.5V7.384A2.499 2.499 0 0 0 15 2.5a2.5 2.5 0 0 0-.75 4.884V9.25h-8.5zM10 16a.999.999 0 1 1 0-2 .999.999 0 1 1 0 2m4-11a.999.999 0 1 1 2 0 .999.999 0 1 1-2 0" })
});
export default SvgSalesProcessRegularIcon;
